export default {
  AS: {
    "footer.button.billOfMaterials": "Artikkelliste",
    "footer.button.export": "Eksport",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Distribusjon Kontakt",
    "footer.button.addToWatchlist": "Legg til i merkeliste",
    "footer.button.requestQuote": "Be om tilbud",
    "header.configurator.title": "Konfigurator",

    "header.links.about.label": "Om asecos",
    "header.links.about.url":
      "https://www.asecos.com/About-asecos/About-asecos/About-asecos/EN_index_3187.html,",
    "header.links.terms.label": "Regler og vilkår",
    "header.links.terms.url":
      "https://www.asecos.com/GTS-asecos-AB/SE_index_1724.html,",
    "header.links.imprint.label": "Impressum",
    "header.links.imprint.url":
      "https://www.asecos.com/Imprint/SE_index_1438.html,",
    "header.links.privacy.label": "Personvern",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/EN/SE/pivacy-policy",

    "dialog.requestQuote.title.success": "Forespørsel sendt",
    "dialog.requestQuote.title.requestQuote": "Be om tilbud",
    "tab.billOfMaterials.title": "Artikkelliste",
    "tab.configurationSummary.title": "Sammendrag av konfigurasjonen",
    "dialog.requestQuote.title.contactData": "Kontakt",
    "dialog.requestQuote.title.companyData": "Bedriftsinformasjon",
    "dialog.requestQuote.label.salutation": "Tittel",
    "dialog.requestQuote.select.salutation.option.female": "Fru",
    "dialog.requestQuote.select.salutation.option.male": "Herr",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Fornavn",
    "dialog.requestQuote.label.lastName": "Etternavn",
    "dialog.requestQuote.label.email": "E-post",
    "dialog.requestQuote.label.phone": "Telefon",
    "dialog.requestQuote.label.company": "Bedrift",
    "dialog.requestQuote.label.country": "Land",
    "dialog.requestQuote.label.postalCode": "Postnummer",
    "dialog.requestQuote.label.city": "By",
    "dialog.requestQuote.label.street": "Gate",
    "dialog.requestQuote.label.number": "Nr",
    "dialog.requestQuote.label.contactHours": "Jeg ber om å bli ringt tilbake",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Formiddag",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Ettermiddag",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Her kan du legge inn foretrukket fagforhandler (dersom kjent)",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Tittel",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Fru",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Herr",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Bedrift",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Fornavn",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Etternavn",
    "dialog.requestQuote.label.specialistRetailer.email": "E-post",
    "dialog.requestQuote.label.specialistRetailer.city": "By",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/EN/SE/pivacy-policy",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/EN/NO/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=EN",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Jeg har lest <privacyLink>Henvisninger</privacyLink> om personvern og aksepterer disse. I tillegg er jeg innforstått med behandling, bruk og videre levering av mine opplysninger til en fagforhandler iht. <consentLink>Samtykkeerklæringen.</consentLink>",
    "dialog.requestQuote.label.comment": "Kommentar",
    "SubconfigurationNavigation.resetItem": "Tilbakestill gruppe",
    "SubconfigurationNavigation.previousItem": "Tilbake",
    "SubconfigurationNavigation.nextItem": "Neste",
    "form.field.error.email": "E-post ugyldig",
    "form.field.error.phone": "Telefonnummer ugyldig",
    "validation.required": "Dette feltet er obligatorisk",
    "footer.button.save": "Spar",
    "footer.button.load": "Last opp",

    "dialog.requestQuote.success.message":
      "Takk for din interesse for asecos og våre produkter. Du vil i løpet av de neste minuttene motta en bekreftelse på den oppgitte e-postadressen din, inkludert konfigurasjonsdataene dine som PDF- og JSON-fil. Med sistnevnte kan du åpne konfigurasjonen din på nytt ved å klikke på opplastingsknappen. \n\nasecos-produkter selges gjennom autoriserte forhandlere. Derfor videresender vi forespørselen din til en passende asecos-partner. Denne vil utarbeide et uforpliktende tilbud i henhold til konfigurasjonen din og om nødvendig ta kontakt med deg.",
    "dialog.requestQuote.success.close": "Lukk",
    "dialog.requestQuote.error.message":
      "Det oppstod en feil under sending av forespørselen din. Vennligst prøv igjen senere.",
  },
};
